import type { AuthStatusCode } from "@anydo/interfaces";
import { AnydoError } from "./AnydoError";

export class AnydoAuthError extends AnydoError<"AUTH", AuthStatusCode> {
  // NOTE: Yes `true`
  readonly isAnydoAuthError = true as const;
  readonly code: AuthStatusCode;

  static isAnydoAuthError(obj: any): obj is AnydoAuthError {
    return obj && obj.isAnydoAuthError && true;
  }

  constructor(code: AuthStatusCode, message = "") {
    super("AUTH", message);
    this.code = code;
  }
}
